import { render } from "./TripRecordComponent.vue?vue&type=template&id=5f8a752a&scoped=true"
import script from "./TripRecordComponent.vue?vue&type=script&lang=ts"
export * from "./TripRecordComponent.vue?vue&type=script&lang=ts"

import "./TripRecordComponent.vue?vue&type=style&index=0&id=5f8a752a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f8a752a"

export default script